import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';

const CancelSessionDialog = ({
  open,
  session,
  loading = false,
  onClose,
  onConfirm,
}) => {
  const learnerName = session?.student?.firstName || 'this learner';

  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onClose}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle>
        <div className="flex items-center justify-between">
          <span className="text-xl font-bold text-gray-900">
            Cancel Session
          </span>
          <button
            type="button"
            onClick={onClose}
            className="text-gray-400 transition-colors hover:text-gray-600"
            disabled={loading}
            aria-label="Close cancellation confirmation"
          >
            <svg
              className="h-6 w-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
      </DialogTitle>
      <DialogContent>
        <div className="py-4">
          <div className="mb-4 flex items-center justify-center">
            <div className="flex h-16 w-16 items-center justify-center rounded-full bg-red-100">
              <svg
                className="h-8 w-8 text-red-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                />
              </svg>
            </div>
          </div>
          <h3 className="mb-2 text-center text-lg font-semibold text-gray-900">
            Are you sure you want to cancel this session?
          </h3>
          <p className="text-center text-sm text-gray-600">
            This will cancel your session with {learnerName}. This action
            cannot be undone.
          </p>
        </div>
      </DialogContent>
      <DialogActions className="px-6 pb-4">
        <Button onClick={onClose} color="inherit" disabled={loading}>
          No, Keep Session
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="error"
          disabled={loading}
        >
          {loading ? 'Cancelling…' : 'Yes, Cancel Session'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CancelSessionDialog;
